<template>
  <div class="general">
    <div class="general-item">
      <jContentBox :title="title1">
        <div slot="boxBody" class="map-box">
          <div class="map"></div>
          <div class="legend">
            图例:
            <p v-for="item,index in legendData">
              <span class="legend-border" :style="{'background-color':legendColors[index]}"></span>
              <span class="legend-item">{{item}}</span></p>
          </div>

          <div class="circle" @mouseover="toggleTooltip" @mouseout="toggleTooltip"></div>
          <div class="tooltip-box" v-if="isShow">
            <div class="title">{{tooltipTitle}}</div>
            <div v-for="item,index in typeNames">{{item}}:<span class="content">{{contents[index]}}</span></div>
          </div>
        </div>
      </jContentBox>
    </div>

    <div class="general-item mgl-2">
      <jContentBox2 :title="title2" @change="change" @selectChange="selectChange">
        <div slot="chartBox" class="chart-box">
          <div class="chart" id="pieChart" :style="{'z-index':zIndex1}"></div>
          <div class="chart" id="barLineChart" :style="{'z-index':zIndex2}"></div>
        </div>
      </jContentBox2>
    </div>
  </div>
</template>

<script>
  import jContentBox from '../../components/jContentBox.vue'
  import jContentBox2 from '../../components/jContentBox2.vue'
  import {generalCharts} from '../../visus/generalCharts'
  import {echartsMixin} from '../../assets/js/common/mixin'
  export default {
    components: {jContentBox, jContentBox2},
    name: "general",
    mixins: [echartsMixin],
    data(){
      return {
        title1: '区域分布',
        title2: '面积分布',
        tabPosition: '等级',
        barLineChart: '',
        pieChart: '',
        zIndex1: 99,
        zIndex2: 98,
        legendColors: ['#3af9db', '#43baff', '#f7e22e', '#ffa13c'],
        legendData: ['优等地', '高等地', '中等地', '低等地'],
        typeNames: ['耕地面积', '耕地等别', '所在地址'],
        contents: ['1675（万亩）', '低等地', '建明镇大路村A地块'],
        tooltipTitle: '月湖区',
        isShow: false
      }
    },
    methods: {
      toggleTooltip(){
        this.isShow = !this.isShow
      },
      _resizeHanlder(){
        if (this.pieChart && this.pieChart.resize) {
          this.drawPie()
        }
        if (this.barLineChart && this.barLineChart.resize) {
          this.barLineChart.resize()
        }
      },
      selectChange(val){

      },
      change(val){
        if (val === '等级') {
          this.zIndex1++
          this.zIndex2--
        } else {
          this.zIndex2++
          this.zIndex1--
          if (this.barLineChart === '') {
            this.drawBarLine()
          }
        }
      },
      drawPie(){
        setTimeout(() => {
          this.pieChart = generalCharts.drawPie('pieChart', this.$echarts)
        },300)
      },
      drawBarLine(){
        setTimeout(() => {
          this.barLineChart = generalCharts.drawBarLine('barLineChart', this.$echarts)
        },300)
      },
      _destroyHandler(){
        if (this.pieChart !== '') {
          this.pieChart.dispose()
        }
        if (this.barLineChart !== '') {
          this.barLineChart.dispose()
        }
      }
    },
    mounted(){
      this.drawPie()
    }
  }
</script>

<style lang="scss" scoped>
  .general {
    height: 433px;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

  .general-item {
    /*float: left;*/
    width: calc((100% - 20px)/2);

    height: 433px;
    box-sizing: border-box;
    .content-box2 {
      height: 100%;
    }
  }



  .chart-box, .map-box {
    box-sizing: border-box;
    position: relative;
    width: 100%;
    height: calc(100% - 30px);
  }

  .chart {
    width: 100%;
    height: 340px;
    position: absolute;
    top: 0;
    left: 0;
  }

  .map {
    position: absolute;
    top: 0;
    left: 50%;
    background: url('../../../static/img/mapBig.jpg') no-repeat;
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    transform: translate(-50%, 0);
    z-index: 90;
  }

  .legend {
    z-index: 91;
    position: absolute;
    bottom: 10px;
    right: 30px;
    height: 12px;
    font-size: 12px;
    color: #ffffff;
    margin-bottom: 110px;
  }

  .legend-item {
    display: inline-block;
    line-height: 16px;
  }

  .legend-border {
    display: inline-block;
    width: 16px;
    height: 3px;
    margin-right: 5px;
    border-radius: 1px;
    margin-bottom: 3px;
  }

  .tooltip-box {
    z-index: 91;
    display: inline-block;
    width: 180px;
    height: 88px;
    background-color: #002624;
    border: solid 1px rgba(0, 255, 238, 0.5);
    font-size: 12px;
    line-height: 21px;
    padding: 10px;
    border-radius: 8px;
    position: absolute;
    left: 38%;
    top: 25%;
    letter-spacing: 0px;
    color: #cccccc;

  .content {
    color: #4cd5ff;
    margin-left: 3px;
  }

  .title {
    text-align: center;
    color: #ffffff;
  }

  }
  .circle {
    z-index: 92;
    display: inline-block;
    width: 80px;
    height: 80px;
    background-color: transparent;
    position: absolute;
    left: 36%;
    top: 42%;
    border-radius: 50%;
    cursor: pointer;
  }

  }

</style>



// WEBPACK FOOTER //
// src/pages/quality/general.vue